import { useContext, useEffect, useState } from "react"
import { DataContext } from "../data/DataContext"
import { DropDown, Tooltip } from '../components'
import { catPlan, catCoveragesName, catSumInsuredColones, catSumInsuredDolar } from '../data/MochaData'
import { IconCheck } from '../img'
import { roundToTwo } from '../data/Help'

const StepPlansCoverage = ({ loadData = false }: IPropsStep) => {
    const { vidaCR, setVidaCR, changeHandler, changeHandler2 } = useContext(DataContext);

    const GetNameCoverage = (id: number) => catCoveragesName.find(x => x.value == id.toString())?.text;
    const GetValue = (id: number, val: string) => id === 538 ? "Incluida" : val;
    const GetPlanHire = () => {
        if (vidaCR.plan === '611')
            return catSumInsuredColones.map((x, i) => { return { value: (i + 1).toString(), text: `Plan ${i + 1} ` } as ICatalog })
        else if (vidaCR.plan === '610')
            return catSumInsuredDolar.map((x, i) => { return { value: (i + 1).toString(), text: `Plan ${i + 1} ` } as ICatalog })
        return []
    }

    const ChangePlanSelected = (prop: string, value: any) => {
        const planSelected = vidaCR.lstRateResumen[parseInt(value) - 1]
        let fees = roundToTwo(planSelected.total / parseInt(vidaCR.nQuotas)).toString()
        setVidaCR({ ...vidaCR, feePay: fees, [prop]: value })
    }

    return (
        <>
            <DropDown
                dataProvider={catPlan}
                field='plan'
                label='Moneda de su póliza'
                onChangeSelect={changeHandler2}
                valueSelect={vidaCR.plan}
                id='plan'
                useToolTip
                titleToolTip="Moneda"
                textToolTip="Es la moneda con la que debe pagar Seguros LAFISE a tus beneficiarios."
            />


            <DropDown
                dataProvider={vidaCR.catQuotas}
                field='nQuotas'
                label='¿En cuantas cuotas lo desea pagar?'
                onChangeSelect={changeHandler2}
                valueSelect={vidaCR.nQuotas}
                id='nQuotas'
                useToolTip
                titleToolTip="Cuotas"
                textToolTip="Puede pagar su póliza de contado o en cuotas dejando un medio de pago registrado."
                loading={loadData}
                loadingText="Cargando cuotas..."
            />


            {vidaCR.lstRateResumen.map((x, index) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }} >
                        <div className="card-vida-cr mt-20">
                            <div className="card-header">
                                <div className="plan">Plan {index + 1}</div>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <div className="" style={{ color: '#008866', textAlign: 'center' }}>Prima</div>
                                        <Tooltip id={`tooltipoPrima_${index}`} text="Prima de acuerdo a la cuotas seleccionada" title="Prima"></Tooltip>
                                    </div>

                                    <div className="" style={{ color: '#4D4D4D', fontSize: '20px', fontWeight: 600 }}>{x.bonusFrecuenciaStr}</div>
                                </div>
                            </div>
                            <table className="mb-10" >
                                <thead style={{ textAlign: 'left' }}>
                                    <th style={{ width: '60%', color: '#4D4D4D', padding: 0, fontSize: '14px', fontWeight: 500 }} colSpan={2}>Cobertura</th>
                                    <th style={{ color: '#4D4D4D', padding: 0, fontSize: '14px', fontWeight: 500 }}>Suma Asegurada</th>
                                </thead>
                                <tbody>
                                    <tr></tr>
                                    {x.coveragesDetail.sort((x: IRatesTable, y: IRatesTable) => ((x.idcob ?? 0) - (y.idcob ?? 0))).map(x => {
                                        return (
                                            <>
                                                <tr style={{ color: '#4D4D4D', padding: 0, fontSize: '15px' }}>
                                                    <td><IconCheck /></td>
                                                    <td >{GetNameCoverage(x.idcob ?? 0)}</td>
                                                    <td style={{ color: '#008866', fontWeight: 500 }}>{GetValue(x.idcob ?? 0, x.value)}</td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            })}


            {vidaCR.lstRateResumen.length > 0 &&
                <>
                    <div className="mt-20 mb-10" >
                        <label style={{ color: '#4D4D4D', fontSize: '20px', fontWeight: 500 }}>Seleccione el plan de su preferencia</label>
                    </div>
                    <DropDown
                        dataProvider={GetPlanHire()}
                        field='planSelected'
                        label='Plan a contratar'
                        onChangeSelect={ChangePlanSelected}
                        valueSelect={vidaCR.planSelected}
                        id=''
                        useToolTip
                        textToolTip="Se refiere al plan de su preferencia según los datos de la tabla anterior."
                        titleToolTip="Plan"
                    />
                </>
            }
        </>
    );
}

export { StepPlansCoverage }